import React from 'react';
import { Grid } from 'semantic-ui-react';
import CohortQueryMenu from '../queries/containers/CohortQueryMenu';
import CohortInfoGridRows from './CohortInfoGridRows';

const CohortBuildingGrid = ({
  code,
  category,
  isNew,
  queryAccess,
}) => (
  <Grid>
    {!isNew && (<CohortInfoGridRows code={code} category={category} />)}
    {queryAccess && (
      <Grid.Row>
        <Grid.Column>
          <CohortQueryMenu code={code} category={category} />
        </Grid.Column>
      </Grid.Row>
    )}
  </Grid>
);

export default CohortBuildingGrid;
